/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  createReducerName,
  createCombineReducers
} from 'mt-react-common/modules/comments/reducers/list/reducer';
import CommentsFromUser from '../../CommentsFromUserList/index';

class CommentsOut extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: createReducerName(`commentsList-userId${this.props.userId}`)
    };
  }

  componentWillMount() {
    createCombineReducers(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <CommentsFromUser
          {...this.props}
          reducerName={this.state.reducerName}
        />
      </React.Fragment>
    );
  }
}

CommentsOut.defaultProps = {};

CommentsOut.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  commentsOwnerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  commentsOutStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired
};

export default CommentsOut;



// WEBPACK FOOTER //
// ./src/components/Comment/ReducerWrappers/CommentsOut/CommentsOut.js